import useDecimalSeparator from "src/hooks/personalization/useDecimalSeparator";
import { ValueFormat } from "src/requests/templates/types";
import { useLocalizationString } from "src/store/localization/useSelectors";
import { useMaxDecimalCount } from "src/store/personalization/useSelectors";
import getEnrichedValueWithDelimiterAndZeros from "./getEnrichedValueWithDelimiterAndZeros";
import {
  doesStringContainsNumber,
  getValueWithAllNumbersEnriched,
  isNumberDecimal,
  isStringOnlyNumber,
} from "./utils";

type GetFormattedDecimalValue = (
  valueToFormat: string | number | null | undefined,
  format?: ValueFormat
) => string | undefined;

const useGetFormattedDecimalValue = (): GetFormattedDecimalValue => {
  const maxDecimalCount = useMaxDecimalCount();
  const commonSeparator = useDecimalSeparator();

  const getFormattedDecimalValue: GetFormattedDecimalValue = (
    valueToFormat,
    format
  ) => {
    if (valueToFormat === undefined || valueToFormat == null) return undefined;

    const stringTypedVal = String(valueToFormat);

    if (!isNumberDecimal(format)) return stringTypedVal;

    if (isStringOnlyNumber(stringTypedVal, format)) {
      return getEnrichedValueWithDelimiterAndZeros(
        stringTypedVal,
        commonSeparator,
        maxDecimalCount
      );
    }

    if (doesStringContainsNumber(stringTypedVal, format)) {
      return getValueWithAllNumbersEnriched(
        stringTypedVal,
        commonSeparator,
        maxDecimalCount,
        format
      );
    }

    return stringTypedVal;
  };

  return getFormattedDecimalValue;
};

export default useGetFormattedDecimalValue;
